import { render, staticRenderFns } from "./LsportDetail.vue?vue&type=template&id=6caf9746&scoped=true"
import script from "./LsportDetail.vue?vue&type=script&lang=js"
export * from "./LsportDetail.vue?vue&type=script&lang=js"
import style0 from "./LsportDetail.vue?vue&type=style&index=0&id=6caf9746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf9746",
  null
  
)

export default component.exports